import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApeStatusCardComponent, StatusCardData } from "../../components/ape-status-card/ape-status-card.component";

/**
 * Layout dei 3 KPI in testa alla pagina di monitoraggio Goal Setting.
 * Riusa ApeStatusCardComponent senza espanderne l'API.
 */
@Component({
  selector: "monitoring-goal-setting-details-counters-template",
  standalone: true,
  imports: [
    CommonModule,
    ApeStatusCardComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./monitoring-goal-setting-details-counters-template.component.html"
})
export class MonitoringGoalSettingDetailsCountersTemplateComponent {
  @Input() countersCardData: StatusCardData[] = [];

  trackCardByIndex(index: number): number {
    return index;
  }
}
